import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe384536"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "ion-padding-start ion-padding-end"
}
const _hoisted_2 = { class: "swiper" }
const _hoisted_3 = { class: "swiper-wrapper" }
const _hoisted_4 = { class: "ion-padding ion-margin-bottom" }
const _hoisted_5 = { class: "display-flex ion-justify-content-between ion-align-items-center ion-padding-bottom" }
const _hoisted_6 = { class: "correct-count" }
const _hoisted_7 = { class: "display-flex ion-justify-content-between ion-align-items-center submit-answer-container ion-margin-bottom" }
const _hoisted_8 = { class: "display-flex ion-justify-content-between ion-align-items-center ion-padding-bottom" }
const _hoisted_9 = { class: "display-flex ion-justify-content-between ion-align-items-center ion-padding-bottom" }
const _hoisted_10 = { class: "capitalize" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "swiper-pagination" }, null, -1))
const _hoisted_12 = { class: "ion-padding" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_firecracker_header = _resolveComponent("firecracker-header")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_firecracker_header, {
        "header-title": "Guessing Word",
        "content-id": "guessing-game",
        "menu-id": "guessing-game-menu",
        type: "MENU"
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        id: "guessing-game"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "display-flex ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                sizeXs: "12",
                sizeSm: "10",
                sizeMd: "8",
                sizeLg: "6",
                sizeXl: "6"
              }, {
                default: _withCtx(() => [
                  (_ctx.isLoading)
                    ? (_openBlock(), _createBlock(_component_spinner, { key: 0 }))
                    : _createCommentVNode("", true),
                  (_ctx.isLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createVNode(_component_ion_card_subtitle, { class: "ion-text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Preparing the guessing game for today ... ")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vocabularies, (vocabulary, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "swiper-slide"
                        }, [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                              _createElementVNode("div", null, [
                                _withDirectives(_createVNode(_component_font_awesome_icon, {
                                  icon: vocabulary.isCorrect ? _ctx.correctIcon : _ctx.incorrectIcon,
                                  class: _normalizeClass(`${
                                                    vocabulary.isCorrect
                                                        ? 'firecracker-primary-color-icon'
                                                        : 'firecracker-warning-color-icon'
                                                } icon-font`)
                                }, null, 8, ["icon", "class"]), [
                                  [_vShow, typeof vocabulary.isCorrect === 'boolean']
                                ])
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_ion_card_subtitle, {
                                  class: "ion-text-end",
                                  "aria-label": `${_ctx.correctAnswerCount} correct words out of ${_ctx.vocabularies.length}`
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.correctAnswerCount), 1),
                                    _createTextVNode(" / " + _toDisplayString(_ctx.vocabularies.length), 1)
                                  ]),
                                  _: 1
                                }, 8, ["aria-label"])
                              ])
                            ]),
                            _createVNode(_component_ion_card_header, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_card_title, { class: "ion-text-center capitalize ion-padding-bottom" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(vocabulary.meaning), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_ion_textarea, {
                                class: "no-border no-focus",
                                "aria-label": "Guess the word",
                                placeholder: "Guess the word",
                                inputmode: "text",
                                autocapitalize: "sentences",
                                "auto-grow": true,
                                value: _ctx.givenAnswer,
                                onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onGivingAnswer($event.detail.value as string)))
                              }, null, 8, ["value"]),
                              _createVNode(_component_ion_button, {
                                "aria-label": "Show the correct word",
                                fill: "clear",
                                size: "large",
                                shape: "round",
                                color: "primary",
                                strong: true,
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCorrectAnswer = true))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, {
                                    icon: _ctx.viewIcon,
                                    class: "firecracker-primary-color-icon"
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_button, {
                                "aria-label": "Submit the answer",
                                fill: "clear",
                                size: "large",
                                shape: "round",
                                color: "primary",
                                class: "ion-padding-end",
                                strong: true,
                                onClick: ($event: any) => (_ctx.submitAnswer(vocabulary, index))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: _ctx.submitIcon }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: vocabulary.isCorrect ? _ctx.correctIcon : _ctx.incorrectIcon,
                                  class: _normalizeClass(`${
                                                    vocabulary.isCorrect
                                                        ? 'firecracker-primary-color-icon'
                                                        : 'firecracker-warning-color-icon'
                                                } icon-font`)
                                }, null, 8, ["icon", "class"])
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_ion_card_subtitle, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.resultMessage), 1)
                                  ]),
                                  _: 1
                                })
                              ])
                            ], 512), [
                              [_vShow, _ctx.resultMessage && !_ctx.showCorrectAnswer]
                            ]),
                            _withDirectives(_createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: _ctx.infoIcon,
                                  class: "firecracker-primary-color-icon icon-font"
                                }, null, 8, ["icon"])
                              ]),
                              _createElementVNode("div", null, [
                                _createVNode(_component_ion_card_subtitle, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" The correct word is \""),
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(vocabulary.word), 1),
                                    _createTextVNode("\". ")
                                  ]),
                                  _: 2
                                }, 1024)
                              ])
                            ], 512), [
                              [_vShow, _ctx.showCorrectAnswer]
                            ])
                          ])
                        ]))
                      }), 128))
                    ]),
                    _hoisted_11
                  ], 512), [
                    [_vShow, !_ctx.isLoading && _ctx.vocabularies.length]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_modal, {
            "is-open": _ctx.isInfoModalOpened,
            "initial-breakpoint": 0.25,
            breakpoints: [0, 0.25, 0.5, 0.75],
            onWillDismiss: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isInfoModalOpened = false))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_ion_card_subtitle, { class: "ion-text-center" }, {
                  default: _withCtx(() => [
                    _createTextVNode(" In this Vocabulary Guessing Game, you'll be presented with a series of meanings to guess the correct word for each one. Each day, a new game will be generated for you to challenge your vocabulary skills. For every correct guess, your score will increase. If you successfully guess all the words correctly, you'll unlock another game to play even on the same day. Challenge yourself daily and see how many words you can get right! ")
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["is-open"]),
          _createVNode(_component_ion_fab, {
            vertical: "bottom",
            horizontal: "end",
            slot: "fixed"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_fab_button, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isInfoModalOpened = true))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: _ctx.ideaIcon }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}